import axios from "axios";
import { API_CONFIG, API_CONFIG_BE } from "@/config/api";

// 创建axios实例
const request = axios.create({
  baseURL: API_CONFIG.BASE_URL,
  timeout: API_CONFIG.TIMEOUT,
});

// 请求拦截器
request.interceptors.request.use(
  (config) => {
    // 这里可以添加请求头等配置
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器
request.interceptors.response.use(
  (response) => {
    // 这里可以对响应数据进行处理
    return response;
  },
  (error) => {
    let errorMessage = API_CONFIG.ERROR_MESSAGES.DEFAULT_ERROR;

    if (error.code === "ECONNABORTED") {
      errorMessage = API_CONFIG.ERROR_MESSAGES.TIMEOUT_ERROR;
    } else if (!error.response) {
      errorMessage = API_CONFIG.ERROR_MESSAGES.NETWORK_ERROR;
    } else if (error.response.status >= 500) {
      errorMessage = API_CONFIG.ERROR_MESSAGES.SERVER_ERROR;
    }

    return Promise.reject({
      error,
      message: errorMessage,
    });
  }
);

export const chatApi = {
  // 发送消息知识库
  // async *sendMessage(params) {
  //   // 创建一个完整的回答对象
  //   const message = {
  //     type: "assistant",
  //     content: "",
  //     status: "thinking",
  //   };

  //   try {
  //     // 发送请求
  //     const queryParams_word = new URLSearchParams({
  //       keyword: params.keyword,
  //       tokens: params.tokens,
  //       session: params.session,
  //     }).toString();
  //     const response = await fetch(
  //       `${API_CONFIG.BASE_URL}${API_CONFIG.CHAT_ENDPOINT}?${queryParams_word}`,
  //       {
  //         method: "GET",
  //       }
  //     );

  //     if (!response.ok) {
  //       throw new Error(`HTTP error! status: ${response.status}`);
  //     }

  //     const data = await response.json();

  //     if (data.data.result_list && data.data.result_list[0]) {
  //       const resultItem = data.data.result_list[0];
  //       // 保留result_list[0]中的所有字段
  //       Object.assign(message, resultItem);

  //       if (resultItem.content) {
  //         message.status = "answering";
  //         // 模拟流式返回,每次返回一个字符
  //         for (let i = 0; i < resultItem.content.length; i++) {
  //           message.content = resultItem.content.slice(0, i + 1);
  //           yield { ...message };
  //           // 添加适当的延迟,使显示更自然
  //           await new Promise((resolve) => setTimeout(resolve, 10));
  //         }
  //       }
  //     }

  //     // 标记完成
  //     message.status = "complete";
  //     yield { ...message };
  //   } catch (error) {
  //     const errorMessage =
  //       error.message || API_CONFIG.ERROR_MESSAGES.DEFAULT_ERROR;
  //     console.error("API请求失败:", error);
  //     throw {
  //       error,
  //       message: errorMessage,
  //     };
  //   }
  // },

  async *sendMessage(params) {
    // 发送消息deepseek
    const message = {
      type: "assistant",
      content: "",
      thinking: "",
      status: "thinking",
      isThinkingComplete: false,
    };

    let response = null;
    let reader = null;

    try {
      // 构建查询参数
      const queryParams = new URLSearchParams({
        keyword: params.keyword,
        tokens: params.tokens,
        session: params.session,
      }).toString();

      response = await fetch(
        `${API_CONFIG.BASE_URL}${API_CONFIG.CHAT_ENDPOINT}?${queryParams}`,
        {
          method: "GET",
          signal: params.signal, // 添加 signal 参数用于中断请求
        }
      );

      if (response.status !== 200) {
        message.status = "error";
        message.content = `${response.data?.message || "请求失败"}`;
        yield { ...message };
        return;
      }

      reader = response.body.getReader();
      const decoder = new TextDecoder();
      let buffer = "";
      let accumulatedContent = "";
      let accumulatedThinking = "";

      try {
        while (true) {
          const { done, value } = await reader.read();
          if (done) {
            // 当数据流结束时，标记消息完成
            message.status = "complete";
            yield { ...message };
            break;
          }

          buffer += decoder.decode(value, { stream: true });
          const lines = buffer.split("\n");
          buffer = lines.pop() || "";

          for (const line of lines) {
            const trimmedLine = line.trim();
            if (!trimmedLine || !trimmedLine.startsWith("data:")) continue;

            try {
              const jsonData = trimmedLine.slice(5); // 移除 "data:" 前缀
              const data = JSON.parse(jsonData);

              // 处理thinking阶段
              if (data.data && data.data.reasoning_content) {
                accumulatedThinking += data.data.reasoning_content;
                message.thinking = accumulatedThinking;
                yield { ...message };
                // 添加thinking的打字效果延迟
                await new Promise((resolve) =>
                  setTimeout(resolve, API_CONFIG_BE.TYPING_SPEED)
                );
              }

              // 处理content阶段
              if (data.data && data.data.generated_answer) {
                accumulatedContent += data.data.generated_answer;
                message.content = accumulatedContent;
                if (message.status === "thinking") {
                  message.status = "answering";
                }
                yield { ...message };
                // 添加content的打字效果延迟
                await new Promise((resolve) =>
                  setTimeout(resolve, API_CONFIG_BE.TYPING_SPEED)
                );
              }
              // 处理文档信息
              if (data && data.length > 0) {
                try {
                  message.doc_info = data;
                  yield { ...message };
                } catch (e) {
                  console.error("解析文档信息出错:", e);
                }
              }
            } catch (e) {
              console.error("解析数据出错:", e, trimmedLine);
            }
          }
        }
      } catch (error) {
        if (error.name === "AbortError") {
          // 请求被中断时，需要清理资源
          if (reader) {
            await reader.cancel();
          }
          message.status = "complete";
          yield { ...message };
          throw error;
        }
        throw error;
      }

      // 处理buffer中剩余的数据
      if (buffer.trim()) {
        try {
          const trimmedLine = buffer.trim();
          if (trimmedLine.startsWith("data:")) {
            const jsonData = trimmedLine.slice(5);
            const data = JSON.parse(jsonData);

            if (data.data) {
              if (data.data.reasoning_content) {
                accumulatedThinking += data.data.reasoning_content;
                message.thinking = accumulatedThinking;
                yield { ...message };
              }

              if (data.data.generated_answer) {
                accumulatedContent += data.data.generated_answer;
                message.content = accumulatedContent;
                if (message.status === "thinking") {
                  message.status = "answering";
                }
                // 处理文档信息
                if (
                  data.data &&
                  typeof data.data === "string" &&
                  data.data.startsWith("[{")
                ) {
                  try {
                    const docInfo = JSON.parse(data.data);
                    if (Array.isArray(docInfo)) {
                      message.doc_info = docInfo;
                      yield { ...message };
                    }
                  } catch (e) {
                    console.error("解析文档信息出错:", e);
                  }
                }
                yield { ...message };
              }
            }
          }
        } catch (e) {
          console.error("解析剩余数据出错:", e, buffer);
        }
      }
    } catch (error) {
      // 如果是中断请求导致的错误，直接抛出
      if (error.name === "AbortError") {
        console.log("请求被手动中断");
        message.status = "complete";
        yield { ...message };
        return;
      }
      const errorMessage =
        error.message || API_CONFIG_BE.ERROR_MESSAGES.DEFAULT_ERROR;
      console.error("API请求失败:", error);
      throw {
        error,
        message: errorMessage,
      };
    } finally {
      // 确保在任何情况下都清理资源
      if (reader && !reader.closed) {
        try {
          await reader.cancel();
        } catch (e) {
          if (e.name !== "AbortError") {
            console.error("清理reader资源失败:", e);
          }
        }
      }
    }
  },
  async *sendMessage_BE(params) {
    // 发送消息deepseek
    const message = {
      type: "assistant",
      content: "",
      thinking: "",
      status: "thinking",
      isThinkingComplete: false,
    };

    let response = null;
    let reader = null;

    try {
      // 构建查询参数
      const queryParams = new URLSearchParams({
        keyword: params.keyword,
        tokens: params.tokens,
        session: params.session,
        image_name: params.image_name,
        is_image: params.is_image,
      }).toString();

      response = await fetch(
        `${API_CONFIG_BE.BASE_URL}${API_CONFIG_BE.CHAT_ENDPOINT}?${queryParams}`,
        {
          method: "GET",
          signal: params.signal, // 添加 signal 参数用于中断请求
        }
      );      
      if (response.status !== 200) {
        message.status = "error";
        message.content = `${response.data?.message || "请求失败"}`;
        yield { ...message };
        return;
      }

      reader = response.body.getReader();
      const decoder = new TextDecoder();
      let buffer = "";
      let accumulatedContent = "";
      let accumulatedThinking = "";

      try {
        while (true) {
          const { done, value } = await reader.read();
          if (done) break;

          buffer += decoder.decode(value, { stream: true });
          const lines = buffer.split("\n");
          buffer = lines.pop() || "";

          for (const line of lines) {
            const trimmedLine = line.trim();
            if (!trimmedLine || !trimmedLine.startsWith("data: ")) continue;

            if (trimmedLine === "data: [DONE]") {
              message.status = "complete";
              yield { ...message };
              return;
            }

            try {
              const jsonData = trimmedLine.slice(6);
              const data = JSON.parse(jsonData);
              if (data.choices && data.choices[0]) {
                const delta = data.choices[0].delta;

                // 处理thinking阶段
                if (delta.reasoning_content) {
                  accumulatedThinking += delta.reasoning_content;
                  message.thinking = accumulatedThinking;
                  yield { ...message };
                  // 添加thinking的打字效果延迟
                  await new Promise((resolve) =>
                    setTimeout(resolve, API_CONFIG_BE.TYPING_SPEED)
                  );
                  continue;
                }

                // 处理content阶段
                if (delta.content) {
                  accumulatedContent += delta.content;
                  message.content = accumulatedContent;
                  if (message.status === "thinking") {
                    message.status = "answering";
                  }
                  yield { ...message };
                  // 添加content的打字效果延迟
                  await new Promise((resolve) =>
                    setTimeout(resolve, API_CONFIG_BE.TYPING_SPEED)
                  );
                }
              }
            } catch (e) {
              console.error("解析数据出错:", e, trimmedLine);
            }
          }
        }
      } catch (error) {
        if (error.name === "AbortError") {
          // 请求被中断时，需要清理资源
          if (reader) {
            await reader.cancel();
          }
          message.status = "complete";
          yield { ...message };
          throw error;
        }
        throw error;
      }

      // 处理buffer中剩余的数据
      if (buffer.trim()) {
        try {
          const trimmedLine = buffer.trim();
          if (trimmedLine.startsWith("data: ")) {
            if (trimmedLine === "data: [DONE]") {
              message.status = "complete";
              yield { ...message };
              return;
            }

            const jsonData = trimmedLine.slice(6);
            const data = JSON.parse(jsonData);
            if (data.choices && data.choices[0]) {
              const delta = data.choices[0].delta;

              if (delta.reasoning_content) {
                accumulatedThinking += delta.reasoning_content;
                message.thinking = accumulatedThinking;
                yield { ...message };
              }

              if (delta.content) {
                accumulatedContent += delta.content;
                message.content = accumulatedContent;
                if (message.status === "thinking") {
                  message.status = "answering";
                }
                yield { ...message };
              }
            }
          }
        } catch (e) {
          console.error("解析剩余数据出错:", e, buffer);
        }
      }

      if (message.status !== "complete") {
        message.status = "complete";
        yield { ...message };
      }
    } catch (error) {
      // 如果是中断请求导致的错误，直接抛出
      if (error.name === "AbortError") {
        console.log("请求被手动中断");
        message.status = "complete";
        yield { ...message };
        return;
      }
      const errorMessage =
        error.message || API_CONFIG_BE.ERROR_MESSAGES.DEFAULT_ERROR;
      console.error("API请求失败:", error);
      throw {
        error,
        message: errorMessage,
      };
    } finally {
      // 确保在任何情况下都清理资源，但跳过已经被中断的情况
      if (reader && !reader.closed) {
        try {
          await reader.cancel();
        } catch (e) {
          // 如果是 AbortError，说明流已经被中断，可以忽略这个错误
          if (e.name !== "AbortError") {
            console.error("清理reader资源失败:", e);
          }
        }
      }
    }
  },

  // 获取历史记录
  async getHistory(params_history) {
    try {
      const { page_num, page_count, platform, tokens } = params_history;
      const queryParams_history = new URLSearchParams({
        page_num,
        page_count,
        platform,
        tokens,
      }).toString();
      const response = await request.get(
        `${API_CONFIG.BASE_URL}/v1/history?${queryParams_history}`
      );
      return response.data;
    } catch (error) {
      console.error("获取历史记录失败:", error);
      throw error;
    }
  },

  // 获取历史对话详情
  async getHistoryDetail(params_details) {
    const { session, page_num, page_count, platform, tokens } = params_details;
    const params_details_infor = new URLSearchParams({
      session,
      page_num,
      page_count,
      platform,
      tokens,
    }).toString();
    try {
      const response = await request.get(
        `${API_CONFIG.BASE_URL}/v1/history_details?${params_details_infor}`
      ); // 这里需要替换为实际的历史详情接口
      return response.data;
    } catch (error) {
      console.error("获取历史对话详情失败:", error);
      throw error;
    }
  },
  // 新建会话时创建ai对话
  async createAiDialog(create_params) {
    const { tokens, platform } = create_params;
    const create_params_new = new URLSearchParams({
      platform,
      tokens,
    }).toString();
    try {
      const response = await request.get(
        `${API_CONFIG.BASE_URL}/v1/create?${create_params_new}`
      );
      return response.data;
    } catch (error) {
      console.error("创建AI对话失败:", error);
    }
  },
  // 修改记录状态status
  async updateStatus(update_params) {
    const { session, tokens } = update_params;
    const update_params_new = new URLSearchParams({
      session,
      tokens,
    }).toString();
    try {
      const response = await request.get(
        `${API_CONFIG.BASE_URL}/v1/delete_history_log?${update_params_new}`
      );
      return response.data;
    } catch (error) {
      console.error("修改记录状态失败:", error);
    }
  },
  // 上传图片
  async uploadImage(params) {
    const { file, tokens } = params;
    const formData = new FormData();
    formData.append("file", file);
    formData.append("tokens", tokens);

    try {
      const response = await request.post(
        `${API_CONFIG.BASE_URL}/v1/upload`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("上传图片失败:", error);
      throw error;
    }
  },
};
